<template>
  <div class="wdx login text-center">
    <div class="email-sent-icon"></div>

    <div class="mt-4">
      <p class="mb-1">Email with login link was sent to</p>
      <p class="font-weight-bold">
        {{ email }}
      </p>
    </div>

    <div class="row mt-3 login-block" v-if="notification">
      <div class="col">
        <div class="notification p-3 text-center">
          {{ notification }}
        </div>
      </div>
    </div>

    <div class="mt-5">
      <button
        type="button"
        class="btn btn-info btn-sm px-4 mr-2 position-relative"
        @click="resendEmail()"
        :disabled="resendLoading"
      >
        <div
          class="spinner-border spinner-border-sm text-primary login-spinner"
          role="status"
          v-if="resendLoading"
        >
          <span class="sr-only">Loading...</span>
        </div>
        Resend Link
      </button>
    </div>

    <div class="mt-4">
      <router-link to="/">Change Email Address</router-link>
    </div>
  </div>
</template>

<script>
import WdxBaseComponentMixin from '../../common/mixins/wdxBaseComponent';
import { ResendEmailStatus } from '../utils/constants';

export default {
  mixins: [WdxBaseComponentMixin],
  data() {
    return {
      notification: null,
      resendLoading: false
    };
  },
  computed: {
    email() {
      return this.$store.state.loginStore.registrationEmail;
    }
  },
  mounted: function () {
    if(!this.email){
      this.$router.push({ name: 'signin' });
    }
    if (this.$route.query.registered) {
      this.notification =
        'Email with login link was sent earlier. Please, check your email box and follow instructions in the message.';
    }
  },
  methods: {
    resendEmail() {
      if (this.$commonService.isEmptyOrWhitespaceString(this.email)) return;

      this.resendLoading = true;
      this.$userService
        .resendEmail(this.email)
        .then((response) => {
          this.resendLoading = false;
          this.setNotification(response.data);
        })
        .catch((error) => {
          this.resendLoading = false;
          if (error && error.response && error.response.status == 400) {
            this.notification = error.response.data.Message;
            return;
          }

          this.handleHttpError(error, true);
        });
    },

    setNotification(responseCode) {
      switch (responseCode) {
        case ResendEmailStatus.Success:
          this.notification = 'Email with login link was sent';
          break;
        case ResendEmailStatus.UserNotFound:
          this.notification = 'User with specified email was not found';
          break;
        case ResendEmailStatus.UserAlreadyRegistered:
          this.notification =
            'User with specified email completed the registration process';
          break;
        case ResendEmailStatus.TimeoutIsNotPassed:
          this.notification =
            "You can't resend email just now. You'll be able to make this action in 30 minutes";
          break;
      }
    }
  }
};
</script>

<style scoped>
.login .login-spinner {
  margin-left: -70px;
}
</style>
